import React, { FC } from "react";
// import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
// import SectionHistory from "./SectionHistory";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>About || Booking React Template</title>
      </Helmet>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />

      <div className="container py-16 lg:py-14 space-y-16 lg:space-y-28">
        <SectionHero
          rightImg={"/rentrips-putih.png"}
          heading="👋 Tentang Kami"
          btnText=""
          subHeading="Rentrips.id merupakan marketplace yang berfokus pada menyediakan barang-barang sewa kebutuhan travelling. Sebagai marketplace, rentrips berperan sebagai pihak ketiga yang menghimpun vendor (pemilik barang) dan pencari barang-barang sewa. Rentrips membuka peluang secara gratis bagi setiap pemilik barang yang ingin mendapatkan keuntungan dari sewa-menyewa. Juga, rentrips mendukung penggunaan barang secara berkelanjutan dengan menyediakan platform bagi masyarakat yang memiliki barang tidak terpakai."
        />

        {/* <SectionHistory className="container py-16 lg:py-28 space-y-16 lg:space-y-28"
        rightImg={rightImg}
          heading="Awal Mula Rentrips.id"
          subHeading1="Rentrips.id bermula dari pandangan dan keinginan untuk menjadi pribadi yang bebas ketika menjalani kehidupan yang sudah semakin rumit ini. Bagaimana seseorang dapat menikmati dunia jika selalu terkekang hal-hal yang membuatnya tidak nyaman? Ditengah semakin majunya teknologi pula, kini gaya hidup manusia semakin bergeser dengan hasrat untuk selalu memiliki barang namun tidak selamanya membutuhkan. Akhirnya banyak yang ingin kembali bebas, memilih untuk menjunjung fungsionalitas dan bergerak memilih kehidupan minimalis."
          subHeading2="Sehingga, rentrips memiliki mimpi untuk dapat mendukung kebebasan itu. Menikmati dunia dengan perjalanan yang lebih mudah dan nyaman tanpa perlu takut untuk memikirkan ruang atau biaya kepemilikan suatu barang. Dengan mengkolaborasikan teknologi dan komunitas, rentrips hadir sebagai wadah bagi siapa saja yang ingin berbagi kebermanfaatan untuk mencapai kebebasan dalam perjalanan. ">

        </SectionHistory> */}

        {/* <SectionFounder /> */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay />
        </div>

        <SectionStatistic />

        <SectionSubscribe2 />
      </div>
    </div>
  );
};

export default PageAbout;
